import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { BannersConfigModel } from '../../../models/section-configuration.model';

@Component({
    selector: 'general-banners-configuration',
    templateUrl: 'general-banners-configuration.component.html',
    styleUrls: ['general-banners-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralBannersConfigurationComponent implements OnInit {
  @Input() bannersConfig: BannersConfigModel;
  @Input() parentFormGroup: FormGroup;

  constructor(private readonly fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.parentFormGroup.addControl('interval', this.fb.control(this.bannersConfig.interval));
  }
}
